/**
 * Keep the browser console clean and show a single branded credit banner.
 * Runs once at app boot — silences log/warn/error/info/debug noise from the app
 * and common third-party libraries that write to console.
 */

const SILENCED_METHODS = [
  "log",
  "info",
  "warn",
  "error",
  "debug",
  "trace",
  "table",
  "dir",
  "dirxml",
  "group",
  "groupCollapsed",
  "groupEnd",
  "time",
  "timeEnd",
  "timeLog",
  "count",
  "countReset",
  "assert",
];

let applied = false;

function silenceConsole() {
  const noop = () => {};
  SILENCED_METHODS.forEach((method) => {
    if (typeof console[method] === "function") {
      console[method] = noop;
    }
  });
}

function printCreditBanner(originalLog) {
  const log = typeof originalLog === "function" ? originalLog.bind(console) : () => {};

  log(
    "%c ServiceWRK %c Ticket Management ",
    [
      "background: linear-gradient(90deg, #7b046c 0%, #a21caf 55%, #c026d3 100%)",
      "color: #ffffff",
      "font-weight: 700",
      "font-size: 13px",
      "padding: 6px 10px",
      "border-radius: 6px 0 0 6px",
      "letter-spacing: 0.04em",
    ].join(";"),
    [
      "background: #111827",
      "color: #f9fafb",
      "font-weight: 600",
      "font-size: 12px",
      "padding: 6px 12px",
      "border-radius: 0 6px 6px 0",
    ].join(";"),
  );

  log(
    "%c Designed And Developed By %c Tejaswi Sagar (Frontend) %c · %c Rajesh M (Backend) ",
    [
      "background: #f3e8ff",
      "color: #7b046c",
      "font-weight: 700",
      "font-size: 11px",
      "padding: 5px 8px",
      "border-radius: 6px 0 0 6px",
    ].join(";"),
    [
      "background: #7b046c",
      "color: #ffffff",
      "font-weight: 600",
      "font-size: 11px",
      "padding: 5px 8px",
    ].join(";"),
    [
      "background: #111827",
      "color: #d1d5db",
      "font-weight: 500",
      "font-size: 11px",
      "padding: 5px 4px",
    ].join(";"),
    [
      "background: #111827",
      "color: #f9fafb",
      "font-weight: 600",
      "font-size: 11px",
      "padding: 5px 10px",
      "border-radius: 0 6px 6px 0",
    ].join(";"),
  );
}

/**
 * Apply console silence + credit banner. Safe to call once.
 * @returns {{ restore: () => void }} optional restore helpers for local debugging
 */
export function applyConsoleCredit() {
  if (applied || typeof window === "undefined" || typeof console === "undefined") {
    return { restore: () => {} };
  }

  applied = true;

  const originals = {};
  SILENCED_METHODS.forEach((method) => {
    if (typeof console[method] === "function") {
      originals[method] = console[method].bind(console);
    }
  });

  printCreditBanner(originals.log);
  silenceConsole();

  return {
    restore() {
      Object.keys(originals).forEach((method) => {
        console[method] = originals[method];
      });
      applied = false;
    },
  };
}

// Run immediately so this is the first boot side-effect when imported first from main.js
applyConsoleCredit();

export default applyConsoleCredit;
